<template>
	<vxe-modal :loading="loading" v-model="modal" width="500" height="auto" @show="show" title="回单" destroy-on-close
		:showFooter="true">
		<template #default>
			<el-form ref="form" :model="form" label-width="80px" size="mini">
				<el-form-item label="供应商编码">
					<el-input readonly v-model="receiptInfo.code"></el-input>
				</el-form-item>
				<el-form-item label="供应商名称">
					<el-input readonly v-model="receiptInfo.name"></el-input>
				</el-form-item>
				<el-form-item label="微信群ID">
					<el-input readonly v-model="receiptInfo.roomid"></el-input>
				</el-form-item>
				<el-form-item label="下载编码">
					<el-input readonly v-model="receiptInfo.receiptdownloadNo">
						<el-button type="primary" slot="append" icon="el-icon-refresh-left"
							@click="reflashDownloadNo"></el-button>
					</el-input>
				</el-form-item>
			</el-form>
		</template>
		<template #footer>
			<vxe-button status="" content="下载" @click="getReceipt('download')"></vxe-button>
			<vxe-button status="primary" content="发送" @click="getReceipt('send')"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			row: {
				default: () => {
					return null
				}
			},
			receiptType: {
				default: () => {
					return 'CD'
				}
			},
			receiptInfo: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				form: {
					mkcode: '',
					checkstaffid: null,
				},
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				if (this.row) {
					this.form.mkcode = this.row.mkcode
					this.form.checkstaffid = this.row.checkstaffid
					if (!this.form.mkcode) {
						this.form.checkstaffid = this.$store.state.system.user.id
					}
				}
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.activeName = this.device == 'pc' ? 'track' : 0
				this.$emit('hide')
			},
			show() {
				this.activeName = 'track'
				this.init()
			},
			showPhone() {
				this.activeName = 0
				this.handleClickPhone(this.activeName)
			},
			modalShow() {
				this.modal = true
			},
			staffsubmit(e) {
				this.form.checkstaffid = e.data
			},
			submit() {
				this.$api.reconciliationcurrent.setMkCode(this.row.id, this.form).then(() => {
					this.$message.success('操作成功')
					this.$emit('success')
					this.cancel()
				})

				//this.cancel()
			},
			reflashDownloadNo() {
				this.$api.reconciliationcurrent.reflashDownloadNo(this.receiptInfo.purchasecode, {
					type: this.receiptType
				}).then((res) => {
					this.receiptInfo.receiptdownloadNo = res
					this.$message.success('操作成功')
				})

			},
			getReceipt(action) {
				let handle = this.$loading()
				this.$api.reconciliationcurrent.sendReceipt({
					supplierwlnid: this.row.purchasesupplierid,
					id: this.row.id,
					type: this.receiptType,
					action: action
				}).then((res) => {
					this.$loadingclose(handle)
					if (action == 'download') {
						window.open(res, '_blank');
					} else {
						this.$message.success('操作成功')
					}
				}, () => {
					this.$loadingclose(handle)
				})
			},
		},
		components: {

		}
	}
</script>